import './projectsAndSkills.scss';
import { useState } from 'react';
import PortfolioItem from '../../components/portfolioItem/portfolioItem';
import SkillsItem from '../../components/skillsItem/skillsItem';

import translater from '../../img/translater.jpg';
import gmovik from '../../img/gmovik.png';
import sharq from '../../img/sharq.jpg';
import fleex from '../../img/fleex.jpg';
import readManga from '../../img/readManga.png';
import collab from '../../img/collab.jpg';
import woodtech from '../../img/woodtech.jpg';
import kanban1 from '../../img/kanban1.jpg';
import kanban2 from '../../img/kanban2.jpg';
import testing from '../../img/testing.jpg';
import finance from '../../img/homeFin.jpg';

import reactSkill from '../../img/skills/icons8-react.gif';
import jsSkill from '../../img/skills/icons8-javascript.gif';
import cSharp from '../../img/skills/icons8-c-sharp-logo.svg';
import html from '../../img/skills/icons8-html.gif';
import VS from '../../img/skills/icons8-visual-studio.svg';
import VSCode from '../../img/skills/icons8-visual-studio-code-2019.svg';
import Figma from '../../img/skills/icons8-figma.gif';
function ProjectsAndSkills() {

    const [display1, setDisplay1] = useState('flex');
    const [display2, setDisplay2] = useState('none');
    const [btn1, seBtn1] = useState('tabBtn tabBtnPress');
    const [btn2, seBtn2] = useState('tabBtn');

    function switchTab(tab) {
        if (tab) {
            setDisplay1('flex');
            setDisplay2('none');
            seBtn1('tabBtn tabBtnPress');
            seBtn2('tabBtn');
        }
        else if (!tab) {
            setDisplay1('none');
            setDisplay2('flex');
            seBtn1('tabBtn');
            seBtn2('tabBtn tabBtnPress');
        }
    }

    return (
        <>
            <div className='tabMenu'>
                <input className={`${btn1}`} type='button' value='Portfolio' onClick={() => switchTab(true)}></input>
                <input className={`${btn2}`} type='button' value='Skills' onClick={() => switchTab(false)}></input>
            </div>
            <div className='slider'>
                <div style={{ display: `${display1}` }} className='slider__item slider__projects'>
                    <PortfolioItem className='slider__projects__item'
                        img={translater}
                        alt='VkMiniApp'
                        header='VkMiniApp'
                        descr='VK Mini application created using the VKUI library and React'
                        link='https://vk.com/services?w=app51546217_181200749'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={readManga}
                        alt='ReadManga'
                        header='ReadManga'
                        descr='Figma layout for a manga reader app. With an adaptive version'
                        link='https://www.figma.com/proto/9Q9v11bXVfLolaSDNql4Ot/ReadManga?node-id=352-1118&scaling=scale-down&page-id=0%3A1&starting-point-node-id=23%3A481&show-proto-sidebar=1'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={kanban2}
                        alt='Kanban Board v2'
                        header='Kanban Board v2'
                        descr='Kanban board web application using html, css and js. More beautiful. More adaptive'
                        link='https://8cofiman.github.io/KanbanBoard_v2'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={woodtech}
                        alt='Woodtech'
                        header='Woodtech'
                        descr='Multipage site in HTML, CSS and minimal JS'
                        link='https://8cofiman.github.io/Woodtech'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={gmovik}
                        alt='GMovik'
                        header='GMovik'
                        descr='Figma layout for a video hosting'
                        link='https://www.figma.com/file/QZdzXBrMmg4mTYLW87VGOI/GMovik?node-id=0%3A1&t=SY3ZmqMknhOkdDbC-1'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={finance}
                        alt='Home finance'
                        header='Home finance'
                        descr='Desktop App on C# and Windows Form. You can download for watching.'
                        link='https://drive.google.com/file/d/1ZaFNG4C24ESqlOEKOud4nG7zukXmy1bk/view?usp=sharing'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={collab}
                        alt='Collab'
                        header='Collab'
                        descr='Website in pure HTML and CSS'
                        link='https://8cofiman.github.io/Collab'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={kanban1}
                        alt='Kanban Board'
                        header='Kanban Board'
                        descr='Kanban board web application using html, css and js'
                        link='https://8cofiman.github.io/KanbanBoard'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={fleex}
                        alt='Fleex'
                        header='Fleex'
                        descr='The site was created in html and css and is one of the first landings I created'
                        link='https://8cofiman.github.io/Fleex'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={testing}
                        alt='Web app "Testing"'
                        header='Web app "Testing"'
                        descr='With using html, css and js. Created long ago)'
                        link='https://8cofiman.github.io/Testing_WebApp'
                    />
                    <PortfolioItem className='slider__projects__item'
                        img={sharq}
                        alt='SharqTelecom'
                        header='SharqTelecom'
                        descr='Website for provider. On HTML, CSS and JS. Almost the first code...'
                        link='https://8cofiman.github.io/SharqTelecom'
                    />
                </div>
                <div style={{ display: `${display2}` }} className='slider__item slider__skills'>
                    <SkillsItem 
                        img={reactSkill}
                        alt='React'
                        header='React'
                    />
                    <SkillsItem 
                        img={jsSkill}
                        alt='JavaScript'
                        header='JavaScript'
                    />
                    <SkillsItem 
                        img={cSharp}
                        alt='C#'
                        header='C#'
                    />
                    <SkillsItem 
                        img={html}
                        alt='HTML'
                        header='HTML'
                    />
                    <SkillsItem 
                        img={VS}
                        alt='VS'
                        header='VS'
                    />
                    <SkillsItem 
                        img={VSCode}
                        alt='VSCode'
                        header='VSCode'
                    />
                    <SkillsItem 
                        img={Figma}
                        alt='Figma'
                        header='Figma'
                    />
                </div>
            </div>
        </>
    );
}

export default ProjectsAndSkills;
